export default __webpack_public_path__ + "static/media/781.1c9aa245.gif";